import { getDateWithYear } from '../shared/date';
import { formatPrice } from '../shared/currency';

const orderNameMapping = {};

const getOrderName = productId => orderNameMapping[productId];

const orderMapper = {
    toDomain(orderData) {
        return {
            price: formatPrice(orderData.price, orderData.currency),
            name: getOrderName(orderData.productId),
            id: orderData.id,
            productId: orderData.productId,
            downloadLink: orderData.downloadLink,
            purchaseDate: getDateWithYear(orderData.purchaseDate)
        };
    }
};

export {
    orderMapper,
    getOrderName
};
